import React from "react";
import { Col, Row, theme, Tooltip, Typography } from "antd";
import PropTypes from "prop-types";

import QuestionIcon from "@/assets/icons/question.svg?react";
import BaseSvgRenderer from "@/components_v2/Svg/BaseSvgRenderer";

const { Title } = Typography;

const FormField = ({
  label = null,
  field,
  required = false,
  showLabel = true,
  isEdit = true,
  tooltipContent = null,
  labelStyles = {},
}) => {
  const { token } = theme.useToken();

  return (
    <div className="mt-3">
      {showLabel && label && (
        <Row>
          <Col>
            <Title
              level={5}
              className="mb-2"
              style={{ color: token.colorPrimaryText, ...labelStyles }}
            >
              {label}
              {required && isEdit ? (
                <span
                  style={{ paddingLeft: "2px", color: token.colorAsterisk }}
                >
                  *
                </span>
              ) : null}
            </Title>
          </Col>
          {tooltipContent && (
            <Col className="ms-2">
              <Tooltip title={tooltipContent}>
                <BaseSvgRenderer
                  component={QuestionIcon}
                  width="15"
                  height="15"
                />
              </Tooltip>
            </Col>
          )}
        </Row>
      )}
      {React.cloneElement(field, { isEdit })}
    </div>
  );
};

FormField.propTypes = {
  field: PropTypes.element.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  showLabel: PropTypes.bool,
  isEdit: PropTypes.bool,
  tooltipContent: PropTypes.element,
  labelStyles: PropTypes.object,
};

export default FormField;
